import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "../../lib/api";

export default function WholesaleCatalog() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/wholesale/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  return (
    <div className="px-5 lg:px-8 py-8">
      <p className="font-mono text-emerald-400 uppercase tracking-widest text-xs">Wholesale</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Catalog</h1>
      <p className="text-zinc-500 mt-1">Wholesale pricing · Apply your academy branding · Bulk size ordering</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
        {products.map((p) => (
          <div key={p.id} className="bg-[#121216] border border-white/10 rounded-lg overflow-hidden hover:border-emerald-500/40 transition-colors">
            <div className="aspect-square bg-[#0A0A0C]">
              <img src={p.images?.front} alt={p.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-4">
              <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{p.category} · {p.audience}</p>
              <h4 className="font-heading font-bold text-white leading-tight mt-1">{p.name}</h4>
              <div className="flex items-center justify-between mt-2">
                <span className="font-mono text-emerald-400 font-bold">{money(p.wholesale_price)} <span className="text-[10px] text-zinc-500">wholesale</span></span>
              </div>
              <p className="text-[10px] font-mono text-zinc-600 mt-1">MOQ {p.moq || 0}</p>
              <Link to={`/gym/order/${p.id}`} data-testid={`wholesale-configure-${p.id}`} className="btn-green w-full block text-center px-3 py-2.5 rounded-sm text-xs mt-3">
                Configure & Order
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
